import { ITEMS_PER_PAGE } from "src/app/config/pagination.constants";

interface IQueryModel {
    pageNumber: number; 
    pageSize: number;
    sortBy:string;
    sortOrder: string;
}

export class QueryModel implements IQueryModel{
    pageNumber: number = 0; 
    pageSize: number = ITEMS_PER_PAGE;
    sortBy:string = 'id';
    sortOrder: string = 'DESC';
    constructor(pageNo:number, size:number, sortby:string ='id', sortOder:string ='DESC') {
        this.pageNumber = pageNo;
        this.pageSize = size;
        this.sortBy = sortby;
        this.sortOrder = sortOder;
    }
}